<template>
  <footer class="cheerlife-footer">
    <div class="cheerlife-footer__inner">
      <p class="cheerlife-footer__title">CheerLife 生活趣兒</p>
      <p class="cheerlife-footer__company">智采科技股份有限公司</p>
      <div class="cheerlife-footer__links">
        <a href="https://www.cheerlife.io/static/privacy/FAQ.html" target="_blank" rel="noopener noreferrer">常見問題</a>
        <span class="cheerlife-footer__divider">|</span>
        <a href="https://www.cheerlife.io/static/privacy/policy.html" target="_blank" rel="noopener noreferrer">使用者條款</a>
        <span class="cheerlife-footer__divider">|</span>
        <a href="https://www.cheerlife.io/static/joinUs/joinUs.html" target="_blank" rel="noopener noreferrer">聯絡我們</a>
      </div>
      <div class="cheerlife-footer__contact">
        <p>客服專線：<a href="tel:02-2711-7060">02-2711-7060</a></p>
        <p>聯絡信箱：<a href="mailto:cheerlife_support@cheerlife.io">cheerlife_support@cheerlife.io</a></p>
      </div>
      <div class="cheerlife-footer__social">
        <a href="https://www.facebook.com/CheerLife.tw/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"/>
          </svg>
        </a>
        <a href="https://line.naver.jp/ti/p/@cheerlife" target="_blank" rel="noopener noreferrer" aria-label="LINE">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596a.626.626 0 01-.199.031c-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314"/>
          </svg>
        </a>
      </div>
      <p class="cheerlife-footer__copyright">Copyright © {{ currentYear }} CheerLife Technology Corporation</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'CheerLifeFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.cheerlife-footer {
  background-color: #2a2a2a;
  color: #ccc;
  padding: 24px 15px 18px;
  text-align: center;
  font-family: 'Noto Sans TC', sans-serif;
  margin-top: 20px;
}
.cheerlife-footer__inner {
  max-width: 600px;
  margin: 0 auto;
}
.cheerlife-footer__title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 4px;
  letter-spacing: 1px;
}
.cheerlife-footer__company {
  font-size: 12px;
  color: #bbb;
  margin: 0 0 14px;
}
.cheerlife-footer__links {
  margin-bottom: 10px;
  font-size: 13px;
}
.cheerlife-footer__links a {
  color: #ddd;
  text-decoration: none;
}
.cheerlife-footer__links a:hover {
  color: #fff;
  text-decoration: underline;
}
.cheerlife-footer__divider {
  margin: 0 8px;
  color: #666;
}
.cheerlife-footer__contact {
  margin-bottom: 10px;
  font-size: 13px;
}
.cheerlife-footer__contact p {
  color: #ccc;
  margin: 2px 0;
}
.cheerlife-footer__contact a[href^="tel"] {
  color: #ddd;
  text-decoration: none;
}
.cheerlife-footer__contact a[href^="mailto"] {
  color: #8BBF9F;
  text-decoration: none;
}
.cheerlife-footer__social {
  margin-bottom: 12px;
}
.cheerlife-footer__social a {
  color: #ccc;
  margin: 0 8px;
  text-decoration: none;
}
.cheerlife-footer__social a:hover {
  color: #fff;
}
.cheerlife-footer__copyright {
  font-size: 11px;
  color: #bbb;
  margin: 0;
}
</style>
